/* ============================================================
   MOON MILK — Main JavaScript
   ExoTex LLC | drinkmoonmilk.com
   ============================================================ */

(function () {
  'use strict';

  /* ── STATE ── */
  const state = {
    product: 'chai',
    purchaseType: 'sub',
    qty: 1,
    activePlan: 'bimonthly',
    cart: []
  };

  const PRODUCTS = {
    chai:   { name: 'Spiced Moon',  flavor: 'Warming Spice',       desc: 'Cinnamon, cardamom, ginger, clove. Tastes like a chai latte — caffeine free.',           price: 59.99, shopifyVariantId: '52089467535641' },
    cacao:  { name: 'Mayan Moon',   flavor: 'Rich & Dark',         desc: 'Natural + Dutch-process cacao, cinnamon, a tiny pinch of cayenne. A traditional Mexican drink — tastes like a healthy hot chocolate.',  price: 59.99, shopifyVariantId: '52089469239577' },
    golden: { name: 'Golden Moon',  flavor: 'Anti-Inflammatory',   desc: 'Turmeric, ginger, black pepper, vanilla. An ancient Ayurvedic recipe — warming, grounding, and deeply nourishing.',                    price: 59.99, shopifyVariantId: '52089472483609' }
  };

  /* Kaching Subscriptions selling plan IDs - shared across all 3 SKUs */
  const SELLING_PLANS = {
    monthly:   691705348377,
    bimonthly: 691705479449,
    quarterly: 691705512217
  };

  /* Plan discount rates */
  const PLAN_DISCOUNTS = { monthly: 0.15, bimonthly: 0.10, quarterly: 0.10 };

  /* ── CART ── */
  function addToCart() {
    window.__mmHasCart = true; /* suppress email popup once an item is added */
    const p = PRODUCTS[state.product];
    const isSub = state.purchaseType === 'sub';
    /* For one-time: no discount. For subscribe: use the monthly 15% plan by default */
    const sellingPlanId = isSub ? SELLING_PLANS.monthly : null;
    const discount = isSub ? PLAN_DISCOUNTS.monthly : 0;
    const price = p.price * (1 - discount);

    /* --- Shopify AJAX Cart API --- */
    const body = { items: [{ id: Number(p.shopifyVariantId), quantity: state.qty }] };
    if (sellingPlanId) body.items[0].selling_plan = sellingPlanId;

    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(r => r.json())
      .then(data => {
        if (data.status) { showToast('Error adding to cart'); return; }
        window.location.href = '/checkout';
      })
      .catch(() => showToast('Error — please try again'));
  }

  function addSubscription() {
    /* Subscribe section — uses the active plan + first available product (chai by default) */
    const p = PRODUCTS[state.product] || PRODUCTS.chai;
    const sellingPlanId = SELLING_PLANS[state.activePlan];
    const discount = PLAN_DISCOUNTS[state.activePlan];

    const plans = {
      monthly:   { name: 'Monthly Subscription',  price: +(p.price * (1 - 0.15)).toFixed(2) },
      bimonthly: { name: 'Bi-Monthly Bundle',      price: +(p.price * (1 - 0.10)).toFixed(2) },
      quarterly: { name: 'Quarterly Bundle',       price: +(p.price * (1 - 0.10)).toFixed(2) }
    };
    const plan = plans[state.activePlan];

    const body = { items: [{ id: Number(p.shopifyVariantId), quantity: 1, selling_plan: sellingPlanId }] };
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(r => r.json())
      .then(data => {
        if (data.status) { showToast('Error — please try again'); return; }
        window.location.href = '/checkout';
      })
      .catch(() => showToast('Error — please try again'));
  }

  function _addSubscriptionLegacy() {
    const plans = {
      monthly:   { name: 'Monthly Subscription',  price: 50.99 },
      bimonthly: { name: 'Bi-Monthly Bundle',      price: 97.00 },
      quarterly: { name: 'Quarterly Bundle',       price: 144.00 }
    };
    const plan = plans[state.activePlan];
    state.cart.push({ id: Date.now(), name: plan.name, detail: 'Subscribe & Save', price: plan.price, qty: 1 });
    renderCart();
    showToast('Subscription added!');
  }

  function addBundle(bundleId) {
    const bundles = {
      starter: { name: 'Discovery Bundle',    price: 152 },
      double:  { name: 'Double Down Bundle',  price: 107 },
      ritual:  { name: 'Ritual Kit Bundle',   price: 79  },
      sub:     { name: 'Subscriber Bundle',   price: 134 }
    };
    const b = bundles[bundleId];
    state.cart.push({ id: Date.now(), name: b.name, detail: 'Bundle', price: b.price, qty: 1 });
    renderCart();
    showToast('Bundle added!');
  }

  function removeItem(lineKey) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).then(r => r.json()).then(() => renderCart());
  }

  function renderCart() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      const counter = document.querySelector('.mm-nav__cart-count');
      if (counter) counter.textContent = cart.item_count;

      const itemsEl  = document.getElementById('mm-cart-items');
      const footerEl = document.getElementById('mm-cart-footer');
      if (!itemsEl) return;

      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="mm-cart-empty">Your cart is empty.<br>Add a Moon Milk to begin your ritual.</div>';
        if (footerEl) footerEl.style.display = 'none';
        return;
      }

      if (footerEl) footerEl.style.display = 'block';
      itemsEl.innerHTML = cart.items.map(item => `
        <div class="mm-cart-item">
          <div class="mm-cart-item__info">
            <p class="mm-cart-item__name">${item.product_title}</p>
            <p class="mm-cart-item__detail">${item.variant_title || ''}</p>
            <p class="mm-cart-item__price">$${(item.final_line_price / 100).toFixed(2)}</p>
            <button class="mm-cart-item__remove" onclick="window.__mm.removeItem('${item.key}')">Remove</button>
          </div>
        </div>
      `).join('');

      const subtotal = cart.total_price / 100;
      const sub = document.getElementById('mm-cart-subtotal');
      const tot = document.getElementById('mm-cart-total');
      if (sub) sub.textContent = '$' + subtotal.toFixed(2);
      if (tot) tot.textContent = '$' + subtotal.toFixed(2);
    });
  }

  function refreshCartCount() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      const counter = document.querySelector('.mm-nav__cart-count');
      if (counter) counter.textContent = cart.item_count;
    });
  }

  /* ── CART DRAWER ── */
  function toggleCart() {
    document.getElementById('mm-cart-drawer')?.classList.toggle('is-open');
    document.getElementById('mm-cart-overlay')?.classList.toggle('is-open');
  }

  /* ── PRODUCT SELECTION ── */
  function swapPurchaseImage(id) {
    const img = document.getElementById('mm-purchase-img');
    if (!img || !window.__mmImages) return;
    const src = window.__mmImages[id];
    if (!src) return;
    img.style.opacity = '0';
    img.style.transform = 'scale(0.97)';
    setTimeout(() => {
      img.src = src;
      img.style.opacity = '1';
      img.style.transform = 'scale(1)';
    }, 180);
  }

  function selectProduct(id) {
    state.product = id;
    document.querySelectorAll('.mm-product-card').forEach(el => el.classList.remove('is-active'));
    document.querySelectorAll('.mm-flavor-option').forEach(el => el.classList.remove('is-selected'));
    const card = document.getElementById('mm-card-' + id);
    const flv  = document.getElementById('mm-flv-'  + id);
    if (card) card.classList.add('is-active');
    if (flv)  flv.classList.add('is-selected');
    swapPurchaseImage(id);
    updatePurchasePanel();
    const panel = document.getElementById('mm-purchase');
    if (panel) panel.scrollIntoView({ behavior: 'smooth' });
  }

  function selectFlavor(id) {
    state.product = id;
    document.querySelectorAll('.mm-product-card').forEach(el => el.classList.remove('is-active'));
    document.querySelectorAll('.mm-flavor-option').forEach(el => el.classList.remove('is-selected'));
    const card = document.getElementById('mm-card-' + id);
    const flv  = document.getElementById('mm-flv-'  + id);
    if (card) card.classList.add('is-active');
    if (flv)  flv.classList.add('is-selected');
    swapPurchaseImage(id);
    updatePurchasePanel();
  }

  function selectPurchaseType(type) {
    state.purchaseType = type;
    document.getElementById('mm-opt-onetime')?.classList.toggle('is-selected', type === 'onetime');
    document.getElementById('mm-opt-sub')?.classList.toggle('is-selected',     type === 'sub');
    updatePurchasePanel();
  }

  function changeQty(delta) {
    state.qty = Math.max(1, state.qty + delta);
    const display = document.getElementById('mm-qty-display');
    if (display) display.textContent = state.qty;
    updatePurchasePanel();
  }

  function updatePurchasePanel() {
    const p    = PRODUCTS[state.product];
    const name = document.getElementById('mm-purchase-name');
    const flvr = document.getElementById('mm-purchase-flavor');
    const desc = document.getElementById('mm-purchase-desc');
    if (name) name.textContent = p.name;
    if (flvr) flvr.textContent = p.flavor;
    if (desc) {
      desc.style.opacity = '0';
      setTimeout(function() {
        desc.textContent = p.desc;
        desc.style.opacity = '1';
      }, 120);
    }

    const base  = state.purchaseType === 'sub' ? p.price * 0.85 : p.price;
    const total = base * state.qty;
    const totEl = document.getElementById('mm-price-total');
    if (totEl) totEl.textContent = '$' + total.toFixed(2);

    const savEl = document.getElementById('mm-price-savings');
    if (savEl) {
      if (state.purchaseType === 'sub') {
        savEl.textContent = 'You save $' + ((p.price - base) * state.qty).toFixed(2) + '/order';
        savEl.style.display = 'block';
      } else {
        savEl.style.display = 'none';
      }
    }

    /* Sync sticky mobile CTA price (V4 layout: separate amount span) */
    const stickyAmt = document.querySelector('.mm-sticky-mobile__amt');
    const stickyLbl = document.querySelector('.mm-sticky-mobile__lbl');
    if (stickyAmt) {
      stickyAmt.textContent = '$' + total.toFixed(2);
    }
    if (stickyLbl) {
      stickyLbl.textContent = state.purchaseType === 'sub' ? 'Sub & Save 15%' : 'One-time';
    }
  }

  /* ── SUBSCRIBE PLANS ── */
  function selectPlan(id) {
    state.activePlan = id;
    document.querySelectorAll('.mm-plan').forEach(el => {
      el.classList.remove('is-active');
      const btn = el.querySelector('.mm-plan__btn');
      if (btn) btn.textContent = 'Select';
    });
    const el = document.getElementById('mm-plan-' + id);
    if (el) {
      el.classList.add('is-active');
      const btn = el.querySelector('.mm-plan__btn');
      if (btn) btn.textContent = 'Selected';
    }
  }

  /* ── SELECT PLAN AND SUBSCRIBE IMMEDIATELY ── */
  function selectPlanAndSubscribe(id) {
    selectPlan(id);
    addSubscription();
  }

  /* ── BUNDLES ── */
  function selectBundle(id) {
    document.querySelectorAll('.mm-bundle').forEach(el => el.classList.remove('is-active'));
    document.getElementById('mm-bundle-' + id)?.classList.add('is-active');
    addBundle(id);
  }

  /* ── TOAST ── */
  function showToast(msg) {
    const t = document.getElementById('mm-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    setTimeout(() => t.classList.remove('is-visible'), 2800);
  }

  /* ── SCROLL REVEAL ── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    const style = document.createElement('style');
    style.textContent = '.mm-reveal{opacity:0;transform:translateY(24px);transition:opacity .6s ease,transform .6s ease}.mm-reveal.is-visible{opacity:1;transform:none}';
    document.head.appendChild(style);
    document.querySelectorAll('.mm-reveal').forEach(el => {
      const obs = new IntersectionObserver(entries => {
        entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); } });
      }, { threshold: 0.1 });
      obs.observe(el);
    });
  }

  /* ── STICKY MOBILE CTA — reveal once past the midpoint of the ritual section ──
     Kept hidden through hero + products + first half of ritual so it never
     double-ups with an in-view CTA. Reveals ~halfway through the education. */
  function initStickyCTAVisibility() {
    const sticky = document.getElementById('mm-sticky-mobile');
    if (!sticky) return;
    sticky.classList.add('is-hidden');

    const ritual = document.getElementById('mm-ritual');
    /* Fallback: if ritual section missing, reveal after the purchase section
       bottom passes the top of the viewport. */
    const purchase = document.getElementById('mm-purchase');

    function check() {
      let show = false;
      if (ritual) {
        const r = ritual.getBoundingClientRect();
        show = (r.top + r.height * 0.5) < 0;
      } else if (purchase) {
        const p = purchase.getBoundingClientRect();
        show = p.bottom < 0;
      } else {
        show = window.scrollY > window.innerHeight * 1.5;
      }
      sticky.classList.toggle('is-hidden', !show);
    }

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  /* ── MM-VS MATRIX HIGHLIGHT — position the lavender capsule over the
     Moon Milk column. The highlight div lives outside the <table> (browsers
     reparent arbitrary divs inside tables) so we compute column offsets
     from its sibling <table> and project onto the matrix container. */
  function initMatrixHighlight() {
    const matrices = document.querySelectorAll('.mm-matrix');
    if (!matrices.length) return;

    function position() {
      const narrow = window.innerWidth < 640;
      const pad = narrow ? -2 : 6;
      const yPad = narrow ? 6 : 10;
      matrices.forEach(matrix => {
        const table = matrix.querySelector('.mm-matrix__table');
        const col = table && table.querySelector('th.mm-col');
        const hl = matrix.querySelector('[data-col-highlight]');
        if (!col || !hl) return;
        const colRect = col.getBoundingClientRect();
        const tableRect = table.getBoundingClientRect();
        hl.style.left = (colRect.left - tableRect.left - pad) + 'px';
        hl.style.width = (colRect.width + pad * 2) + 'px';
        hl.style.top = yPad + 'px';
        hl.style.bottom = yPad + 'px';
      });
    }
    position();
    window.addEventListener('resize', position);
    /* Fonts can shift column widths after load — re-run once webfonts settle */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(position);
    } else {
      window.addEventListener('load', position);
    }
  }

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', () => {
    renderCart();
    initReveal();
    initStickyCTAVisibility();
    initMatrixHighlight();
    /* Sync price display with default purchase type on load */
    updatePurchasePanel();
  });

  /* Shopify theme editor re-renders sections in place when settings change.
     Re-init the matrix highlight so the lavender capsule repositions. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.mm-matrix')) {
      initMatrixHighlight();
    }
  });

  /* ── MOBILE MENU ── */
  function toggleMobileMenu() {
    var menu = document.getElementById('mm-mobile-menu');
    var overlay = document.getElementById('mm-mobile-overlay');
    var burger = document.getElementById('mm-burger');
    if (!menu) return;
    var isOpen = menu.classList.contains('is-open');
    menu.classList.toggle('is-open', !isOpen);
    if (overlay) overlay.classList.toggle('is-open', !isOpen);
    if (burger) burger.classList.toggle('is-active', !isOpen);
    document.body.classList.toggle('mm-menu-open', !isOpen);
  }

  /* ── EMAIL POPUP ── */
  /* Suppression is per browsing SESSION: once the popup has shown this session it stays
     hidden until the visitor starts a new session (closes the browser / comes back later),
     at which point it shows once again. Confirmed subscribers are suppressed permanently. */
  function popupSeenThisSession() {
    try { return sessionStorage.getItem('mm_popup_seen') === '1'; } catch (e) { return false; }
  }

  function markPopupSeen() {
    try { sessionStorage.setItem('mm_popup_seen', '1'); } catch (e) {}
  }

  function alreadySubscribed() {
    try { return !!localStorage.getItem('mm_email'); } catch (e) { return false; }
  }

  function isExcludedPage() {
    var p = window.location.pathname;
    return p.indexOf('/cart') === 0 || p.indexOf('/checkout') !== -1 || p.indexOf('/orders') !== -1 || p.indexOf('/thank') !== -1;
  }

  function popupShouldSkip() {
    return popupSeenThisSession() || alreadySubscribed() || window.__mmEmailCaptured || window.__mmHasCart || isExcludedPage();
  }

  function showPopup() {
    var overlay = document.getElementById('mm-popup-overlay');
    if (!overlay) return;
    overlay.classList.add('is-visible');
  }

  function closePopup() {
    var overlay = document.getElementById('mm-popup-overlay');
    if (overlay) overlay.classList.remove('is-visible');
    markPopupSeen();
  }

  function handlePopupSubmit(e) {
    e.preventDefault();
    var input = document.getElementById('mm-popup-email');
    if (!input || !input.value) return;
    var email = input.value.trim();
    if (!email) return;

    try { localStorage.setItem('mm_email', email); } catch(ex) {}
    markPopupSeen();
    window.__mmEmailCaptured = true;

    /* POST to Klaviyo client subscriptions API — adds to "Moon Milk Waitlist - Founding 500" list (YrL9cs) and triggers the welcome flow */
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=XMMQwy', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2023-12-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: { type: 'profile', attributes: { email: email } }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: 'YrL9cs' } }
          }
        }
      })
    }).catch(function() {});

    var overlay = document.getElementById('mm-popup-overlay');
    if (overlay) overlay.classList.remove('is-visible');
    showToast("You're in \u2014 your frother code is on the way.");
  }

  /* ── POPUP TRIGGER ──
     Fires 5s after the page opens (per Jordan, Aug 2026 — replaced exit-intent/scroll/25-35s).
     Skips if already shown this session, subscribed, has items in cart, or on cart/checkout/thank-you. */
  function initPopup() {
    var overlay = document.getElementById('mm-popup-overlay');
    if (!overlay) return;
    if (popupShouldSkip()) return;

    setTimeout(function() {
      if (popupShouldSkip()) return;
      /* Mark seen as soon as it's shown so it stays hidden for the rest of this session,
         even if the visitor navigates away without closing it (no re-firing per page). */
      markPopupSeen();
      showPopup();
    }, 5000);
  }

  /* ── SOCIAL PROOF TOAST ── */
  function initProofToast() {
    var cities = ['Austin, TX', 'Denver, CO', 'Los Angeles, CA', 'Brooklyn, NY', 'Chicago, IL', 'Nashville, TN', 'Seattle, WA', 'Portland, OR', 'Miami, FL', 'San Diego, CA', 'Atlanta, GA', 'Phoenix, AZ'];
    var toast = document.getElementById('mm-proof-toast');
    if (!toast) return;
    var textEl = toast.querySelector('.mm-proof-toast__text');
    var timeEl = toast.querySelector('.mm-proof-toast__time');

    function show() {
      var city = cities[Math.floor(Math.random() * cities.length)];
      var mins = Math.floor(Math.random() * 12) + 2;
      if (textEl) textEl.textContent = 'Someone in ' + city + ' just started their ritual';
      if (timeEl) timeEl.textContent = mins + ' minutes ago';
      toast.classList.add('is-visible');
      setTimeout(function() { toast.classList.remove('is-visible'); }, 4000);
    }

    var delay = Math.floor(Math.random() * 15000) + 30000;
    setTimeout(function() {
      show();
      setInterval(show, Math.floor(Math.random() * 15000) + 30000);
    }, delay);
  }

  /* ── INIT (additions) ── */
  document.addEventListener('DOMContentLoaded', function() {
    initProofToast();
    updatePurchasePanel();

    /* Check cart first so we never interrupt someone mid-purchase, then arm the popup */
    window.__mmHasCart = false;
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      window.__mmHasCart = !!(c && c.item_count > 0);
      initPopup();
    }).catch(function(){ initPopup(); });

    var form = document.getElementById('mm-popup-form');
    if (form) form.addEventListener('submit', handlePopupSubmit);

    var closeBtn = document.getElementById('mm-popup-close');
    if (closeBtn) closeBtn.addEventListener('click', closePopup);

    var dismissBtn = document.getElementById('mm-popup-dismiss');
    if (dismissBtn) dismissBtn.addEventListener('click', closePopup);

    var popupOverlay = document.getElementById('mm-popup-overlay');
    if (popupOverlay) {
      popupOverlay.addEventListener('click', function(e) {
        if (e.target === popupOverlay) closePopup();
      });
    }
  });

  /* ── V4 PRODUCT CARDS (mm-purchase) ── */
  function selectCardMode(sku, mode) {
    const card = document.querySelector('.mm-pcard[data-sku="' + sku + '"]');
    if (!card) return;
    card.querySelectorAll('.mm-pcard__opt').forEach(function (el) {
      const active = el.dataset.mode === mode;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    const product = PRODUCTS[sku];
    if (!product) return;

    const amt     = card.querySelector('.mm-pcard__price-amt');
    const strike  = card.querySelector('.mm-pcard__price-strike');
    const cycle   = card.querySelector('.mm-pcard__price-cycle');
    const cta     = card.querySelector('.mm-pcard__cta');
    const serving = card.querySelector('.mm-pcard__meta-serving');
    const cancel  = card.querySelector('.mm-pcard__cancel');
    const SERVINGS_PER_BAG = 25;

    /* "Cancel Anytime" only applies to subscriptions — hide it in one-time mode */
    if (cancel) cancel.style.display = mode === 'sub' ? '' : 'none';

    if (mode === 'sub') {
      const sub = (product.price * (1 - PLAN_DISCOUNTS.monthly)).toFixed(2);
      if (amt)     amt.textContent    = '$' + sub;
      if (strike)  { strike.textContent = '$' + product.price.toFixed(2); strike.style.display = ''; }
      if (cycle)   { cycle.textContent  = '/month'; cycle.style.display = ''; }
      if (cta)     cta.textContent     = 'Start My Ritual — $' + sub;
      if (serving) serving.textContent = '$' + (sub / SERVINGS_PER_BAG).toFixed(2) + '/serving';
    } else {
      if (amt)     amt.textContent = '$' + product.price.toFixed(2);
      if (strike)  strike.style.display = 'none';
      if (cycle)   cycle.style.display  = 'none';
      if (cta)     cta.textContent = 'Add to Cart — $' + product.price.toFixed(2);
      if (serving) serving.textContent = '$' + (product.price / SERVINGS_PER_BAG).toFixed(2) + '/serving';
    }
  }

  function addCardToCart(sku) {
    const card = document.querySelector('.mm-pcard[data-sku="' + sku + '"]');
    if (!card) return;
    const activeOpt = card.querySelector('.mm-pcard__opt.is-active');
    const mode = activeOpt && activeOpt.dataset.mode === 'one' ? 'onetime' : 'sub';
    state.product = sku;
    state.purchaseType = mode;
    state.qty = 1;
    addToCart();
  }

  /* ── PUBLIC API (used by inline onclick attributes) ── */
  window.__mm = { selectProduct, selectFlavor, selectPurchaseType, changeQty, addToCart, addSubscription, selectPlan, selectPlanAndSubscribe, selectBundle, toggleCart, removeItem, toggleMobileMenu, selectCardMode, addCardToCart };

})();
